// @flow
import {createActions} from 'redux-actions';

import type {WindowProductType} from 'constants/flow/flowTypesProduct';

import type {PreloadedProductPayloadType, ProductPayloadType} from './categoryTypes';

export const {
    category: {savePreloadedProduct, openTryOn},
} = createActions({
    CATEGORY: {
        /**
         * Creates save route action payload
         */
        SAVE_ROUTE: () => {},

        /**
         * Creates save preloaded product action payload
         * @param {WindowProductType} product - product
         * @param {number} childrenId - active product children id
         * @param {number} index - product index
         * @return {PreloadedProductPayloadType} payload
         */
        SAVE_PRELOADED_PRODUCT: (
            product: WindowProductType,
            childrenId: number,
            index: number,
        ): PreloadedProductPayloadType => ({product, childrenId, index}),

        /**
         * Creates open try on action payload
         * @param {WindowProductType} product - product
         * @param {number} childrenId - active product children id
         * @return {ProductPayloadType} payload
         */
        OPEN_TRY_ON: (product: WindowProductType, childrenId: number): ProductPayloadType => ({
            product,
            childrenId,
        }),
    },
});
